import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><a parentName="p" {...{
        "href": "https://www.ibm.com/cloud/key-protect"
      }}>{`Key Protect`}</a>{` is a tool that provides centralized management of encryption keys
and sensitive information. Key Protect manages two different types of keys: `}<inlineCode parentName="p">{`root keys`}</inlineCode>{` and `}<inlineCode parentName="p">{`standard keys`}</inlineCode>{`. `}</p>
    <p><inlineCode parentName="p">{`Root keys`}</inlineCode>{` are used to encrypt information in other systems, like the etcd database of the cluster, or data in Object Storage, or a MongoDB database. The details of
which are the subject for a different article. `}</p>
    <p><inlineCode parentName="p">{`Standard keys`}</inlineCode>{` are used to store any kind of protected information. The Key Protect plugin reads the contents of a standard key, identified by a given key id, and
stores the key value into a secret in the cluster.`}</p>
    <h2>{`Getting the Key Protect instance id`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Set the target resource group and region for the Key Protect instance.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`ibmcloud target -g {RESOURCE_GROUP} -r {REGION}
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`List the available resources and find the name of the Key Protect instance.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`ibmcloud resource service-instances
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`List the details for the Key Protect instance. The `}<inlineCode parentName="p">{`Key Protect instance id`}</inlineCode>{` is listed as `}<inlineCode parentName="p">{`GUID`}</inlineCode>{`.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`ibmcloud resource service-instance {INSTANCE_NAME} 
`}</code></pre>
      </li>
    </ol>
    <h2>{`Creating a standard key`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open the IBM Cloud console and navigate to the Key Protect service`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Within Key Protect, select the `}<strong parentName="p">{`Manage Keys`}</strong>{` tab`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Press the `}<inlineCode parentName="p">{`Add key`}</inlineCode>{` button to open the “Add a new key” dialog`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the `}<inlineCode parentName="p">{`Import your own key`}</inlineCode>{` radio button and `}<inlineCode parentName="p">{`Standard key`}</inlineCode>{` from the drop down`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide a descriptive name for the key and paste the base-64 encoded value of the key into the `}<inlineCode parentName="p">{`Key material`}</inlineCode>{` field`}</p>
        <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` A value can be encoded as base-64 from the terminal with the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`echo -n "{VALUE}" | base64
`}</code></pre>
        <p parentName="li">{`If you need to encode a larger value, create the value in a file and encode the entire contents of the file with:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`cat {file} | base64
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Import key`}</strong>{` to create the key`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy the value of the `}<strong parentName="p">{`ID`}</strong></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      